var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.blockClass},[_c('InfoIcon',{staticClass:"tooltip__icon"}),_vm._v(" "),_c('div',{staticClass:"tooltip__copy"},[_vm._v("\n    "+_vm._s(_vm.copy)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }